import store from '@/store'

/**
 * @param {Array} roles 
 * @returns {Boolean}
 * @description Validates the user Roles
 */
export const isAllowedUser = (roles) => {
    return store.state.oidcStore.user.role instanceof Array
        ? roles.find((role) => store.state.oidcStore.user.role.includes(role)) ? true : false
        : roles.find((role) => store.state.oidcStore.user.role == role) ? true : false;
}
